import { __makeTemplateObject } from "tslib";
import { css } from '../styled-components';
import { px } from './px';
/** lineClamp helper */
export function lineClamp(lineNumber, maxHeight) {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: ", ";\n    -webkit-box-orient: vertical;\n    max-height: ", ";\n    word-break: break-word;\n  "], ["\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: ", ";\n    -webkit-box-orient: vertical;\n    max-height: ", ";\n    word-break: break-word;\n  "])), lineNumber, px(maxHeight));
}
var templateObject_1;
